import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <div className="d-flex flex-column" style={{
          backgroundImage: `url(${process.env.REACT_APP_ENDPOINT}/background)`,
          backgroundSize: 'cover',
          height: '100vh',
          fontFamily: 'Lato, sans-serif'
      }}>
          <App />
      </div>
  </React.StrictMode>
);
